import {
  GetLearningBudgetSetupFilters,
  LearningBudgetService,
} from '@/services/learning-budget';
import {
  ApiPaginatedResponse,
  ApiPaginationParams,
  ApiReactQueryOptions,
  ISortingParams,
} from '@/types/api';
import { ILearningBudgetSetupInTheList } from '@/types/learning-budget';
import { useQuery } from '@tanstack/react-query';

type UseLearningBudgetSetupsProps = {
  filters: GetLearningBudgetSetupFilters;
  pagination?: ApiPaginationParams;
  sort?: ISortingParams;
  options?: ApiReactQueryOptions<
    ApiPaginatedResponse<ILearningBudgetSetupInTheList>
  >;
};

export function useLearningBudgetSetups(opts: UseLearningBudgetSetupsProps) {
  const { filters, pagination, sort, options } = opts ?? {};

  return useQuery({
    queryKey: [LearningBudgetService.SETUP_PATH, filters, pagination, sort],
    queryFn: () =>
      LearningBudgetService.getLearningBudgetSetups({
        ...filters,
        ...pagination,
        sort,
      }),
    ...options,
  });
}
